import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { StartComponent } from "./components/StartComponent";
import { InventoryComponent } from "./components/InventoryComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-start", StartComponent);
window.customElements.define("game-inventory", InventoryComponent);
